import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiGetCurrentUser(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/currentuser`);
}

export function apiGetAllUsers(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/users`);
}

export function apiGetAllUsersForSeller(sellerId: any): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/usersForSeller/${sellerId}`);
}

export function apiGetUserDetail(id: number): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/user/${id}`);
}

export function apiUserCreateOrUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/usercreateorupdate`, data);
}

export function apiUserSettingsUpdate(data: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/usersettingsupdate`, data);
}


export function apiDeleteUser(id: number): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/user/${id}`);
}

export function apiChangeLanguage(code: string): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/user/language/${code}`);
}
